import { render, staticRenderFns } from "./SConfirm.vue?vue&type=template&id=479f7df8&"
import script from "./SConfirm.vue?vue&type=script&lang=js&"
export * from "./SConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports